export default __webpack_public_path__ + "static/media/aboutIllustration.d89b20cd.jpg";